module.exports = __webpack_public_path__ + "img/bus-selected.15137693.svg";